export default __webpack_public_path__ + "static/media/Nioicon.9262cde9.eot";